import { render } from "./MyNavbar.vue?vue&type=template&id=5bd3de09"
import script from "./MyNavbar.vue?vue&type=script&lang=js"
export * from "./MyNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__